import React from "react";
import { createRoot } from "react-dom/client";
import HomepageSlider from "../components/HomepageSider/HomepageSlider";

const renderHomepageSlider = ($) => {
	const sliders = $(".js-homepage-slider").toArray();

	if (sliders.length > 0) {

		// Loop through each slider and render the component
		sliders.forEach((slider) => {
			let props = {...slider.dataset};
    
			const root = createRoot(slider);
			root.render(<HomepageSlider {...props} />);
		});

	}
};

export default renderHomepageSlider;
